import { useTypewriter } from "./useTypewriter";

const TypingBullet = ({ text }: { text: string }) => {
  const { output, done } = useTypewriter(text);

  return (
    <li>
      {output}
      {!done && <span className="typing-cursor">|</span>}
    </li>
  );
};

export default TypingBullet;